import { defaultLocale, supportedLocales } from "i18n";
import { type InitOptions } from "i18next";

export const i18nextOptions = {
  fallbackLng: defaultLocale,
  supportedLngs: Array.from(supportedLocales),
  react: { useSuspense: false },
} satisfies InitOptions;
